var TextFieldStatuses;
(function (TextFieldStatuses) {
    TextFieldStatuses["Error"] = "error";
    TextFieldStatuses["Warning"] = "warning";
    TextFieldStatuses["Success"] = "success";
})(TextFieldStatuses || (TextFieldStatuses = {}));

export { TextFieldStatuses };
